module.exports = __webpack_public_path__ + "media/activity-level/normal-hyperactive-01537e8e.svg";